export const disableCheckout = () => {
  // console.log("Disabling checkout");
  document.querySelector("#meal-plan-cart-cta").classList.add("disabled");
  document.querySelector("#mob-next-step").classList.add("disabled");

  enableAddMore();
};

export const activateNextStep = () => {
  // console.log("Activating next step");
  // document.querySelector("#mob-next-step").classList.remove("disabled");
  enableAddMore();
};

export const disableAddMore = () => {
  // console.log("Disabling add more");
  // document.querySelector("#meal-plan-cart-cta").classList.add("disabled");

  const mealPlanAdd = document.querySelectorAll(
    '[js-product-card="container"] meal-plan-adjust[data-kind="Meal"] #quantity-up',
  );
  const mealPlanAdjust = document.querySelectorAll(
    '[js-product-card="container"] meal-plan-adjust[data-kind="Meal"] #quantity-up',
  );
  const mealPlanAddIcon = document.querySelectorAll(
    '[js-product-card="container"] meal-plan-add[data-kind="Meal"]',
  );

  mealPlanAdd.forEach((el) => {
    el.classList.add("disabled");
    el.classList.add("no-events");
  });

  mealPlanAdjust.forEach((el) => {
    el.classList.add("disabled");
    el.classList.add("no-events");
  });

  mealPlanAddIcon.forEach((el) => {
    el.classList.add("disabled");
    el.classList.add("no-events");
  });
};

export const enableAddMore = () => {
  // console.log("Enabling add more");

  const mealPlanAdd = document.querySelectorAll(
    '[js-product-card="container"] meal-plan-adjust[data-kind="Meal"] #quantity-up',
  );
  const mealPlanAdjust = document.querySelectorAll(
    '[js-product-card="container"] meal-plan-adjust[data-kind="Meal"] #quantity-up',
  );
  const mealPlanAddIcon = document.querySelectorAll(
    '[js-product-card="container"] meal-plan-add[data-kind="Meal"]',
  );

  mealPlanAdd.forEach((el) => {
    el.classList.remove("disabled");
    el.classList.remove("no-events");
  });

  mealPlanAdjust.forEach((el) => {
    el.classList.remove("disabled");
    el.classList.remove("no-events");
  });

  mealPlanAddIcon.forEach((el) => {
    el.classList.remove("disabled");
    el.classList.remove("no-events");
  });
};
